export const ROUTES_MAP = ["/dashboard", "/devices", "/media", "/playlists", "/schedules", "/users"];
// const ALL_ROUTES = [
//   "/devices",
//   "/media",
//   "/playlist",
//   "/playlists",
//   "/schedule",
//   "/schedules"
// ];
